<template>
  <div>
    <div class="contact-form" v-if="!isSubmitting">
      <div class="form-header">
        <div class="yagish-logo">
          <img src="@/assets/img/yagi-ask.svg" alt="ヤギのアイコン" class="yagi-icon" />
        </div>
        <h2>お問い合わせ</h2>
        <p class="description">
          yagish（ヤギッシュ）をご利用いただきありがとうございます。<br />
          お問い合わせ対応日時は<b>平日9:00〜18:00</b>とさせていただいております。<br />
          上記時間外にいただいたお問い合わせにつきましては、翌営業日以降に順次対応いたしますので、何卒ご了承ください

        </p>
        <!-- ログイン中のユーザーにのみメールアドレスを表示 -->
        <p v-if="$firebase.isAuthenticated" class="user-email">
          ログイン中のメールアドレス: {{ $firebase.user.email }}
        </p>
        <!-- 未ログインユーザーへのメッセージ -->
        <p v-else class="login-message">
          ※
          <router-link to="/login" class="login-link">ログイン</router-link>すると、メールアドレスが自動入力されます
        </p>
      </div>

      <div class="form-group">
        <label for="name">お名前<span class="required">*</span></label>
        <input id="name" type="text" v-model="form.name" placeholder="名前を入力してください" required />
        <span v-if="errors.name" class="error-message">{{ errors.name }}</span>
      </div>

      <div class="form-group">
        <label for="email">メールアドレス<span class="required">*</span></label>
        <input id="email" type="email" v-model="form.email" placeholder="username@yagish.jp" required />
        <span v-if="errors.email" class="error-message">{{ errors.email }}</span>
      </div>

      <div class="form-group">
        <label>利用環境</label>
        <div class="select-wrapper">
          <select v-model="form.environment" @change="updateForm('environment', $event.target.value)"
            class="styled-select">
            <option value="">利用環境を選択してください</option>
            <option v-for="env in environments" :key="env" :value="env">
              {{ env }}
            </option>
          </select>
        </div>
        <span v-if="errors.environment" class="error-message">{{
          errors.environment
        }}</span>
      </div>

      <div class="form-group">
        <label>お問い合わせ項目</label>
        <div class="select-wrapper">
          <select v-model="form.category" @change="updateForm('category', $event.target.value)" class="styled-select">
            <option value="">お問い合わせ項目を選択してください</option>
            <option v-for="cat in categories" :key="cat" :value="cat">
              {{ cat }}
            </option>
          </select>
        </div>
        <span v-if="errors.environment" class="error-message">{{
          errors.environment
        }}</span>
      </div>

      <div class="form-group">
        <label for="content">お問い合わせまたはリクエストの内容<span class="required">*</span></label>
        <textarea id="content" v-model="form.content" required rows="5"></textarea>
        <span v-if="errors.content" class="error-message">{{
          errors.content
        }}</span>
      </div>

      <div class="privacy-section">
        <label class="checkbox-label">
          <div class="custom-checkbox">
            <input type="checkbox" v-model="form.privacyAccepted"
              @change="updateForm('privacyAccepted', form.privacyAccepted)" />
            <span class="checkmark"></span>
          </div>
          <span class="checkbox-text">プライバシーポリシーに同意する</span>
        </label>
        <p class="privacy-note">
          ※当社の
          <a href="https://www.yagish.jp/privacy_policy/" target="_blank">プライバシーポリシー</a>
          について同意される方のみ送信できます
        </p>
      </div>

      <div class="submit-section">
        <button type="button" :disabled="!form.privacyAccepted || isSubmitting" class="submit-button"
          @click="submitContact">
          お問い合わせ送信
        </button>
      </div>
    </div>
    <div class="contact-form" v-else>
      <div class="form-header">
        <div class="yagish-logo">
          <img src="@/assets/img/yagi-ask.svg" alt="ヤギのアイコン" class="yagi-icon" />
        </div>
        <h2>お問い合わせ</h2>
        <p class="description">
          お問い合わせいただきありがとうございます。<br />
          順次回答させていただきますので、少々お待ちください。
        </p>
        <!-- ログイン中のユーザーにのみメールアドレスを表示 -->
        <p class="user-email">
          メールアドレス: {{ form.email }}
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import _ from '@/assets/lib/my-lodash'
import firebase from 'firebase/app'
export default {
  name: "ContactForm",
  data() {
    return {
      isLoggedIn: false,
      userEmail: null,
      errors: {},
      isSubmitting: false,
      form: {
        name: "",
        email: "",
        environment: "",
        category: "",
        content: "",
        privacyAccepted: false,
      },
      environments: [
        "PCのブラウザ",
        "iPhoneのブラウザ",
        "androidのブラウザ",
        "iPhoneのアプリ",
        "androidのアプリ",
        "その他",
      ],
      categories: [
        "PDF自分にメール",
        "応募先にメール（ヤギのメール便）",
        "コンビニ印刷",
        "郵送を依頼（ヤギの宅配便）",
        "PDF端末に保存",
        "ヤギプライム",
        "ヤギオファー",
        "ヤギタイム",
        "フォント変更",
        "就労支援施設利用者向け履歴書",
        "その他",
      ],
    };
  },
  created() {
    // this.checkAuthStatus();
  },
  methods: {
    submitContact() {
      const app = this

      if (!app.form.name) {
        app.$message({
          message: 'お名前を入力してください',
          type: 'error'
        })
        return
      }
      if (!app.form.email) {
        app.$message({
          message: 'メールアドレスを入力してください',
          type: 'error'
        })
        return
      }
      if (!app.form.content) {
        app.$message({
          message: 'お問い合わせまたはリクエストの内容を入力してください',
          type: 'error'
        })
        return
      }

      const formData = new FormData()
      if (app.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }
      formData.append('name', app.form.name)
      formData.append('email', app.form.email)
      formData.append('environment', app.form.environment)
      formData.append('category', app.form.category)
      formData.append('content', app.form.content)
      formData.append('meta', app.$deviceLib.getUserAgent)
      this.$axios
        .post(this.$varuna.endPoints.registContact, formData, { timeout: 60000 })
        .then(function (response) {
          if (response.data.success) {
            app.$message({
              message: '登録完了しました',
              type: 'success'
            })
            app.isSubmitting = true
          } else {
            app.$message({
              message: '登録失敗しました',
              type: 'error'
            })

          }
        })
    },
    async handleSubmit() {
      try {
        this.isSubmitting = true;

        // バックエンド連携がない場合は、直接遷移
        this.$router.push("/contact/complete");

        /* バックエンド連携する場合
        const user = this.$firebase.auth().currentUser;
        const formData = {
          ...this.form,
          uuid: user ? user.uid : null,
          email: user ? user.email : this.form.email,
        };
        await this.$axios.post("/api/contact", formData);
        this.$router.push("/contact/complete");
        */
      } catch (error) {
        this.errors.submit = error.message;
      } finally {
        this.isSubmitting = false;
      }
    },
    authStateChanged: async function () {
      const app = this
      // app.form.name = this.$firebase.user.email
      app.form.email = this.$firebase.user.email
      if (app.form.email.includes('privaterelay.appleid.com')) {
        app.form.email = '';
      }

      this.$iterateStorage(function (value, key, iterationNumber) {
        if (key === 'basicData') {
          app.form.name = value.lastName + ' ' + value.firstName
        }
      }, function (err) { })

    }
  },
  beforeMount: function () {
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
};
</script>

<style scoped>
.contact-form {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.form-header {
  text-align: center;
  margin-bottom: 2rem;
}

.yagish-logo {
  width: 80px;
  height: 80px;
  margin: 0 auto 1rem;
}

.yagi-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.form-header h2 {
  font-size: 1.75rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #2d5a27;
}

.description {
  color: #666;
  line-height: 1.6;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: #2d5a27;
}

.required {
  color: #e53e3e;
  margin-left: 0.5rem;
  font-size: 0.875rem;
}

input[type="text"],
input[type="email"],
textarea,
.styled-select {
  width: 100%;
  max-width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s;
  height: 45px;
}

textarea {
  height: auto;
}

.select-wrapper {
  position: relative;
}

.select-wrapper::after {
  content: "▼";
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #2d5a27;
  pointer-events: none;
}

.styled-select {
  appearance: none;
  background-color: white;
  cursor: pointer;
}

input:focus,
textarea:focus,
.styled-select:focus {
  outline: none;
  border-color: #2d5a27;
}

.error {
  border-color: #e53e3e;
}

.error-message {
  color: #e53e3e;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.privacy-section {
  margin: 2rem 0;
  padding: 1.5rem;
  background-color: #f8faf8;
  border-radius: 12px;
  text-align: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  cursor: pointer;
}

.custom-checkbox {
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 0.5rem;
}

.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  background-color: white;
  border: 2px solid #2d5a27;
  border-radius: 4px;
}

.custom-checkbox input:checked~.checkmark:after {
  content: "";
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid #2d5a27;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-text {
  margin-left: 0.5rem;
}

.privacy-note {
  font-size: 0.875rem;
  color: #666;
  margin-top: 0.5rem;
}

.privacy-note a {
  color: #2d5a27;
  text-decoration: none;
}

.privacy-note a:hover {
  text-decoration: underline;
}

.submit-section {
  text-align: center;
  margin-top: 2rem;
}

.submit-button {
  background-color: #2d5a27;
  color: white;
  padding: 1rem 3rem;
  border-radius: 8px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  transition: background-color 0.2s;
}

.submit-button:hover:not(:disabled) {
  background-color: #234620;
}

.submit-button:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .contact-form {
    padding: 1rem;
  }

  .submit-button {
    width: 100%;
    padding: 1rem;
  }
}

.login-required {
  text-align: center;
  padding: 2rem;
  background-color: #f8faf8;
  border-radius: 16px;
  margin: 2rem auto;
  max-width: 800px;
}

.login-button {
  background-color: #2d5a27;
  color: white;
  padding: 1rem 2rem;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  margin-top: 1rem;
}

.user-email {
  margin-top: 1rem;
  padding: 0.5rem;
  background-color: #f8faf8;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #2d5a27;
}

.login-message {
  margin-top: 1rem;
  padding: 0.5rem;
  background-color: #f8faf8;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #666;
}

.login-link {
  color: #2d5a27;
  text-decoration: none;
  font-weight: bold;
}

.login-link:hover {
  text-decoration: underline;
}
</style>
